/// <amd-module name="Build/Admin/Pool/Actions/ActionsHub" />
import { ITrendChartData, ITrendChartReportConfiguration } from "Analytics/Shared/TrendChart/Common/Types";
import { AgentActions } from "Build/Admin/Common/Actions/AgentActions";
import { ConfirmationDialogActions } from "Build/Admin/Common/Actions/ConfirmationDialogActions";
import { JobActions } from "Build/Admin/Common/Actions/JobActions";
import { NotificationActions } from "Build/Admin/Common/Actions/NotificationActions";
import { ProjectActions } from "Build/Admin/Common/Actions/ProjectActions";
import { ResourceLimitActions } from "Build/Admin/Common/Actions/ResourceLimitActions";
import { ServiceEndpointActions } from "Build/Admin/Common/Actions/ServiceEndpointActions";
import { SignalRActions } from "Build/Admin/Common/Actions/SignalRActions";
import { VirtualMachineScaleSet } from "Build/Admin/Common/Client/Contracts/DistributedTask/Azure";
import { TimeZoneData } from "Build/Admin/Common/Client/Contracts/DistributedTask/DataProvider";
import { StoreStatus } from "Build/Admin/Common/Constants";
import { IPipelinesConsumptionData } from "Build/Admin/Pool/Types";
import {
    ElasticNode,
    ElasticPool,
    ElasticPoolLog,
    TaskAgent,
    TaskAgentPool,
    TaskAgentPoolMaintenanceDefinition,
    TaskAgentPoolMaintenanceJob,
    TaskAgentQueue
} from "DistributedTask/Client/Contracts/TaskAgent";
import { AgentDefinition } from "PoolProvider/Shared/Contracts/PoolProviderShared";
import { ServiceEndpoint } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";
import { Action } from "VSS/Reflux/Action";

export class ActionsHub {
    public agentActions = new AgentActions();
    public confirmationDialogActions = new ConfirmationDialogActions<TaskAgent | TaskAgentQueue>();
    public jobActions = new JobActions();
    public notificationActions = new NotificationActions();
    public projectActions = new ProjectActions();
    public resourceLimitActions = new ResourceLimitActions();
    public serviceEndpointActions = new ServiceEndpointActions();
    public signalRActions = new SignalRActions();

    public agentPoolDescriptionUpdated = new Action<string>();
    public descriptionStoreStatusUpdated = new Action<StoreStatus>();
    public agentsUpdated = new Action<TaskAgent[] | undefined>();
    public agentDeleted = new Action<TaskAgent>();
    public maintenanceDefinitionsUpdated = new Action<TaskAgentPoolMaintenanceDefinition[]>();
    public maintenanceDefinitionAdded = new Action<TaskAgentPoolMaintenanceDefinition>();
    public maintenanceDefinitionUpdated = new Action<TaskAgentPoolMaintenanceDefinition>();
    public maintenanceJobUpdated = new Action<TaskAgentPoolMaintenanceJob>();
    public maintenanceJobsUpdated = new Action<TaskAgentPoolMaintenanceJob[]>();
    public maintenanceJobsStoreStatusUpdated = new Action<StoreStatus>();
    public maintenanceStoreStatusUpdated = new Action<StoreStatus>();
    public maintenanceTimeZonesUpdated = new Action<TimeZoneData[]>();
    public selectedAgentPoolUpdated = new Action<TaskAgentPool | undefined>();
    public selectedAgentQueueUpdated = new Action<TaskAgentQueue | undefined>();
    public selectedElasticPoolUpdated = new Action<ElasticPool | undefined>();
    public selectedServiceEndpointUpdated = new Action<ServiceEndpoint | undefined>();
    public selectedVirtualMachineScaleSetUpdated = new Action<VirtualMachineScaleSet | undefined>();
    public selectedTabUpdated = new Action<string>();
    public securityStoreStatusUpdated = new Action<StoreStatus>();
    public manageQueuePermissionUpdated = new Action<boolean>();
    public managePoolPermissionUpdated = new Action<boolean>();
    public manageAllQueuesPermissionUpdated = new Action<boolean>();
    public manageAllPoolsPermissionUpdated = new Action<boolean>();
    public agentQueuePipelinesAuthorizedUpdated = new Action<boolean>();
    public agentDefinitionsUpdated = new Action<AgentDefinition[]>();
    public dismissDownloadAgentDialog = new Action<void>();
    public showDownloadAgentDialog = new Action<void>();
    public elasticNodesUpdated = new Action<ElasticNode[]>();
    public elasticNodeUpdated = new Action<ElasticNode>();
    public elasticNodeStoreStatusUpdated = new Action<StoreStatus>();
    public elasticPoolLogsUpdated = new Action<ElasticPoolLog[]>();
    public elasticPoolLogStoreStatusUpdated = new Action<StoreStatus>();
    public checksStoreStatusUpdated = new Action<StoreStatus>();

    // Pool Analytics actions
    public updateConfigurationValuesAction = new Action<ITrendChartReportConfiguration>();
    public updatePublicDataAction = new Action<ITrendChartData>();
    public updatePrivateDataAction = new Action<ITrendChartData>();
    public updateTopFivePipelinesAction = new Action<IPipelinesConsumptionData[]>();
    public onPublicTrendError = new Action<Error>();
    public onPrivateTrendError = new Action<Error>();
    public onPipelineConsumptionError = new Action<Error>();
}
